/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import { Field, withTypes } from 'react-final-form';
import { useLocation } from 'react-router-dom';

import { Button, CircularProgress, TextField } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/styles';

import { Notification, useTranslate, useLogin, useNotify } from 'react-admin';

import {
  Wallpaper,
  Logo,
  LoginActions,
  AvatarContainer,
  InputContainer,
  FormContainer,
  LoginCard,
  LogoContainer,
  MainFormContainer,
} from './CustomLogin.styles';

import CustomTheme from '../theme/CustomTheme';

const renderInput = ({
  meta: { touched, error } = { touched: false, error: undefined },
  input: { ...inputProps },
  ...props
}) => (
  <TextField
    error={!!(touched && error)}
    fullWidth
    helperText={touched && error}
    {...inputProps}
    {...props}
  />
);

const { Form } = withTypes();

const Login = () => {
  const [loading, setLoading] = useState(false);
  const translate = useTranslate();
  const notify = useNotify();
  const login = useLogin();
  const location = useLocation();

  const handleSubmit = (auth) => {
    setLoading(true);
    login(auth, location.state ? location.state.nextPathname : '/').catch(
      (error) => {
        setLoading(false);
        notify(
          // eslint-disable-next-line no-nested-ternary
          typeof error === 'string'
            ? error
            : typeof error === 'undefined' || !error.message
              ? 'ra.auth.sign_in_error'
              : error.message,
          'warning'
        );
      }
    );
  };

  const validate = (values) => {
    const errors = {};
    if (!values.username) {
      errors.username = translate('ra.validation.required');
    }
    if (!values.password) {
      errors.password = translate('ra.validation.required');
    }
    return errors;
  };

  return (
    <Form
      onSubmit={handleSubmit}
      render={({ handleSubmit: submit }) => (
        <form noValidate onSubmit={submit}>
          <MainFormContainer>
            <LoginCard>
              <AvatarContainer>
                <LogoContainer variant="square">
                  <Logo image="/pimec.jpg" />
                </LogoContainer>
              </AvatarContainer>
              <FormContainer>
                <InputContainer>
                  <Field
                    autoFocus
                    component={renderInput}
                    disabled={loading}
                    label={translate('ra.auth.username')}
                    name="username"
                  />
                </InputContainer>
                <InputContainer>
                  <Field
                    component={renderInput}
                    disabled={loading}
                    label={translate('ra.auth.password')}
                    name="password"
                    type="password"
                  />
                </InputContainer>
              </FormContainer>
              <LoginActions>
                <Button
                  color="primary"
                  disabled={loading}
                  fullWidth
                  type="submit"
                  variant="contained"
                >
                  {loading && <CircularProgress size={25} thickness={2} />}
                  {translate('ra.auth.sign_in')}
                </Button>
              </LoginActions>
            </LoginCard>
            <Notification />
          </MainFormContainer>
          <Wallpaper image="/wallpaper.png" />
        </form>
      )}
      validate={validate}
    />
  );
};

Login.propTypes = {};

const CustomLogin = (props) => (
  <ThemeProvider theme={CustomTheme}>
    <Login {...props} />
  </ThemeProvider>
);

export default CustomLogin;
